import { graphql } from '@/gql';
import type { SubmitManualOrderMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const submitManualOrder = async ({
  phoneNumber,
  orderId,
  serviceEmail,
  preferredPhoneNumber,
  clientName,
  isRedelivery,
  originalOrderId,
  natureOfComplaint,
  noteToLP,
  chargeOptions,
  transactionId,
}: SubmitManualOrderMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
      orderId,
      serviceEmail,
      preferredPhoneNumber,
      clientName,
      chargeOptions,
      isRedelivery,
      originalOrderId,
      natureOfComplaint,
      noteToLP,
      transactionId,
    },
    mutation: graphql(`
      mutation SubmitManualOrder(
        $phoneNumber: String!
        $orderId: String!
        $serviceEmail: String!
        $clientName: String
        $preferredPhoneNumber: String
        $chargeOptions: GourmetChargeOptionsInput
        $isRedelivery: Boolean
        $originalOrderId: String
        $natureOfComplaint: String
        $noteToLP: String
        $transactionId: String
      ) {
        submitManualOrder(
          phoneNumber: $phoneNumber
          orderId: $orderId
          serviceEmail: $serviceEmail
          clientName: $clientName
          preferredPhoneNumber: $preferredPhoneNumber
          chargeOptions: $chargeOptions
          isRedelivery: $isRedelivery
          originalOrderId: $originalOrderId
          natureOfComplaint: $natureOfComplaint
          noteToLP: $noteToLP
          transactionId: $transactionId
        ) {
          id
        }
      }
    `),
  });

  return response.data?.submitManualOrder;
};
